import script from "./BookExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookExport.vue?vue&type=script&setup=true&lang=ts"

import "./BookExport.vue?vue&type=style&index=0&id=6d8c1ba2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8c1ba2"]])

export default __exports__